export { default } from './CompaniesChart';
